<cw-ci-data-table #emailDataTable
  tileTitle="Email Templates"
  addToolTip="Create a new email template"
  refreshToolTip="Reload email template list"
  defaultSortField="type"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadEmailTemplates($event)"
  (addHandler)="addEmailTemplate($event)"
  (selectHandler)="editEmailTemplate($event)"
  [items]="emailList">

  <cw-ci-table-column columnName="id" columnTitle="Id" sortField="id"></cw-ci-table-column>
  <cw-ci-table-column columnName="type" columnTitle="Type" sortField="type" filterType="select" [filterOptions]="[{display:'Informational', value:'INFORMATIONAL'}, {display:'Marketing', value:'MARKETING'}, {display:'System Alert', value:'SYSTEM_ALERT'}, {display:'New Assessment', value:'NEW_ASSESSMENT'}, {display:'Completed Assessment', value:'COMPLETED_ASSESSMENT'}]"></cw-ci-table-column>
  <cw-ci-table-column columnName="theme" columnTitle="Theme" sortField="theme" searchField="theme" filterType="select" [filterOptions]="[{display:'ConnectWise', value:'connectwise'}]"></cw-ci-table-column>
  <cw-ci-table-column columnName="subject" columnTitle="Subject" sortField="subject" searchField="subject" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="sender" columnTitle="Sender" sortField="sender" searchField="sender" filterType="text"></cw-ci-table-column>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action actionToolTip="Edit the email template" svgIcon="cw:action_edit" actionColor="primary" [element]="element" (clickHandler)="editEmailTemplate($event)"></cw-ci-table-column-action>
  </ng-template>

</cw-ci-data-table>
